import { lazyLoad } from 'utils/loadable';

export const NurturingJourneySettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.NurturingJourneySettingsComponent,
);
